<template>
<div class="accordian" @click="setActive">
  <slot></slot>
</div>
</template>

<script>
export default {
  name:'accordian',
  methods:{
    setActive(e){
      var con=this.$el,el=e.target;
      if(el!=con){
        while(el.parentNode!=con)el=el.parentNode;
        con.querySelector('.active').classList.remove('active');
        el.classList.add('active');
      }
    }
  }
}
</script>

<style>
.accordian{
  display:flex;
  flex-directino:row;
  margin:5px 0;
}
.accordian>*{
  background:#eee;
  margin:0 5px;
  flex-grow:1;
  width:200px;
}
.accordian>*>.acc-body{
    height:300px;
  }
.accordian>*>.acc-header{
  font-weight:bold;
  height:30px;
  line-height:30px;
  padding:5px;
  color:#eee;
  background-color:#777;
}
.accordian>*>.acc-body{
  margin-top:5px;
}
@media only screen and (max-width : 400px) {
  .accordian{
    flex-direction:column;
  }
  .accordian>*{
    align-self:center;
    min-width:80%
  }
  .accordian>*,.accordian>*>.acc-body{
    transition:height 1s;
  }
  .accordian>.active>.acc-body{
    height:300px;
  }
  .accordian>*>*{
    overflow:hidden;
  }
  .accordian>*>.acc-body{
    height:0;
  }
}

</style>


// WEBPACK FOOTER //
// accordian.vue?31f79179